// /opt/isp_erp/frontend/src/pages/ftth/NapForm.jsx
import React, { useState } from 'react';
import {
  Container,
  Typography,
  Paper,
  TextField,
  Button,
  Grid,
  Box,
  Alert,
  CircularProgress
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ftthAPI } from '../../api/ftth.api';

const NapForm = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [form, setForm] = useState({
    codigo: '',
    nombre: '',
    direccion: '',
    latitud: '',
    longitud: '',
    capacidad_puertos: 8,
    zona: '',
    sector: '',
    ciudad: ''
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await ftthAPI.createNap({
        ...form,
        latitud: parseFloat(form.latitud),
        longitud: parseFloat(form.longitud),
        capacidad_puertos: parseInt(form.capacidad_puertos)
      });
      navigate('/ftth/naps/lista');
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al crear NAP');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="md" sx={{ py: 3 }}>
      <Typography variant="h4" gutterBottom>➕ Agregar Nuevo NAP</Typography>
      <Paper sx={{ p: 3 }}>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField fullWidth label="Código" name="codigo" value={form.codigo} onChange={handleChange} required placeholder="Ej: NAP-001" />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField fullWidth label="Nombre" name="nombre" value={form.nombre} onChange={handleChange} required />
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth label="Dirección" name="direccion" value={form.direccion} onChange={handleChange} required />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField fullWidth type="number" label="Latitud" name="latitud" value={form.latitud} onChange={handleChange} required inputProps={{ step: 0.000001 }} />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField fullWidth type="number" label="Longitud" name="longitud" value={form.longitud} onChange={handleChange} required inputProps={{ step: 0.000001 }} />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField fullWidth type="number" label="Capacidad de Puertos" name="capacidad_puertos" value={form.capacidad_puertos} onChange={handleChange} inputProps={{ min: 1, max: 64 }} />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField fullWidth label="Zona" name="zona" value={form.zona} onChange={handleChange} />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField fullWidth label="Sector" name="sector" value={form.sector} onChange={handleChange} />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField fullWidth label="Ciudad" name="ciudad" value={form.ciudad} onChange={handleChange} />
            </Grid>
          </Grid>
          <Box display="flex" justifyContent="flex-end" gap={2} mt={3}>
            <Button variant="outlined" onClick={() => navigate('/ftth/naps/lista')}>Cancelar</Button>
            <Button type="submit" variant="contained" disabled={loading}>
              {loading ? <CircularProgress size={24} /> : 'Guardar NAP'}
            </Button>
          </Box>
        </form>
      </Paper>
    </Container>
  );
};

export default NapForm;
